import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal, Signal } from '@angular/core';
import { AnimateModule, HeaderComponent, NewsletterComponent } from '@pro-connect/shared';
import { BasicPage, WwwRouteSlug } from '../../../../models';
import { AboutUsSection } from './models/about-us-section';
import { AboutUsTopComponent } from './components/about-us-top/about-us-top.component';
import { AboutUsDescriptionComponent } from './components/about-us-description/about-us-description.component';
import { AboutUsBrandsComponent } from './components/about-us-brands/about-us-brands.component';
import { AboutUsPillarsComponent } from './components/about-us-pillars/about-us-pillars.component';

@Component({
  templateUrl: './about-us.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    AnimateModule,
    HeaderComponent,
    NewsletterComponent,
    AboutUsTopComponent,
    AboutUsDescriptionComponent,
    AboutUsBrandsComponent,
    AboutUsPillarsComponent,
  ],
})
export class AboutUsComponent extends BasicPage {
  public override loading: Signal<boolean> = signal(false);
  protected readonly AboutUsSection = AboutUsSection;
  protected readonly WwwRouteSlug = WwwRouteSlug;

  constructor() {
    super();
  }
}
